import React, { useRef, useEffect, useState } from 'react'
import { AdminTableProps } from '../../models'
import { useAppSelector } from '../../../../app/hooks'
import { selectedLmsAdminSearch, selectedLmsStatus } from '../../lmsSlice'
import { getSearchResults } from '../../utils'
import LinkButton from './LinkButton'
import ProvenanceView from '../../../../components/ProvenanceView'
import {
  create,
  update,
  sampleTableHeadings,
  menuValues,
} from '../../constants'
import { IconButton } from '@mui/material'
import KeycloakService from '../../../../utils/keycloakService'
import { SUPER_ADMIN_DELETE } from '../../../../utils/roles'
import DeleteOutlined from '@mui/icons-material/DeleteOutlined'
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined'
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined'
import '../../../administration/admin.scss'
import { DeleteConfirmationDialog } from './DeleteConfirmationDialog'
import { Archive } from './Archive'

const SampleTable = ({ data, onEdit }: AdminTableProps) => {
  const searchParam = useAppSelector(selectedLmsAdminSearch)
  const status = useAppSelector(selectedLmsStatus)
  const [deleteDialog, setDeleteDialog] = useState<boolean>(false)
  const [tableData, setTableData] = useState<any>(data)
  const [sampleData, setSampleData] = useState<any>({})
  let filtered = getSearchResults(tableData, searchParam)
  filtered = filtered?.filter((d) => d?.status === status)

  filtered?.sort?.((a: { name: string }, b: { name: string }) =>
    a.name?.toLowerCase() < b.name?.toLowerCase() ? -1 : 1
  )

  const sampleTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = sampleTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 20}px`
      }
    }

    window.addEventListener('resize', resizeHandler)
    resizeHandler()

    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])

  useEffect(() => {
    setTableData(data)
  }, [data])

  function handleDeleteDialogOpen(d: any) {
    setDeleteDialog(true)
    setSampleData(d)
  }

  function handleCloseDeleteDialog() {
    setDeleteDialog(false)
    setSampleData(null)
  }

  return (
    <div
      className='data-table table-fixed admin-table-table-container'
      ref={sampleTableContainerRef}
      style={{ overflowY: 'auto' }}
    >
      <table className='data-table table-fixed admin-table relative'>
        <thead style={{ position: 'sticky', top: '0px' }}>
          <tr>
            <th className='table-w-5'>{sampleTableHeadings?.id}</th>
            <th>{sampleTableHeadings?.sampleName}</th>
            <th>{sampleTableHeadings?.description}</th>
            <th className='table-w-10'>{sampleTableHeadings?.createdBy}</th>
            <th className='table-w-10'>{sampleTableHeadings?.updatedBy}</th>
            <th className='table-w-8'>{sampleTableHeadings?.actions}</th>
          </tr>
        </thead>
        <tbody>
          {filtered?.length ? (
            filtered?.map((d: any) => (
              <tr key={d?.id}>
                <td>{d?.id}</td>
                <td>
                  <LinkButton id={d.id} name={d?.name} onClick={onEdit} />
                </td>
                <td>{d?.description}</td>
                <td>
                  <ProvenanceView
                    mode={create}
                    date={d?.created_date ?? ''}
                    name={d?.created_by ?? '-'}
                  />
                </td>
                <td>
                  <ProvenanceView
                    mode={update}
                    date={d?.updated_date ?? ''}
                    name={d?.updated_by ?? '-'}
                  />
                </td>
                <td>
                  <div className='set-action-icons'>
                    {d?.status === 'active' ? (
                      <IconButton
                        title='Archive'
                        size='small'
                        onClick={() =>
                          Archive(d, setTableData, menuValues?.Sample)
                        }
                        disabled={
                          !KeycloakService?.hasRole([SUPER_ADMIN_DELETE])
                        }
                      >
                        <ArchiveOutlinedIcon fontSize='small' />
                      </IconButton>
                    ) : (
                      <IconButton
                        title='un-Archive'
                        size='small'
                        onClick={() =>
                          Archive(d, setTableData, menuValues?.Sample)
                        }
                        disabled={
                          !KeycloakService?.hasRole([SUPER_ADMIN_DELETE])
                        }
                      >
                        <UnarchiveOutlinedIcon fontSize='small' />
                      </IconButton>
                    )}
                    <IconButton
                      title='Delete'
                      size='small'
                      onClick={() => handleDeleteDialogOpen(d)}
                      disabled={!KeycloakService?.hasRole([SUPER_ADMIN_DELETE])}
                    >
                      <DeleteOutlined fontSize='small' />
                    </IconButton>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className='text-center'>
                No Samples Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {deleteDialog && (
        <DeleteConfirmationDialog
          openDialog={deleteDialog}
          closeDialog={handleCloseDeleteDialog}
          data={sampleData}
          name={sampleData?.name}
          setData={setTableData}
          item={menuValues?.Sample}
        />
      )}
    </div>
  )
}

export default SampleTable
